import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'

import { ROLES } from '@/shared/auth/constants'
import { roleAuthGuard } from '@/shared/auth/utils/router'
import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

import {
	SettingsCard,
	SettingsCardTitle,
} from '@/components/common/settings-card'

const InvitationsTable = lazy(
	() => import('@/features/tenant/components/invitations-table'),
)

export const Route = createFileRoute(
	'/_dashboard/settings/tenant-settings/invitations',
)({
	beforeLoad: () => roleAuthGuard(ROLES.Admin),

	head: () => ({
		meta: [
			{
				title: 'Invitations | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RouteSkeleton,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<SettingsCard>
			<SettingsCardTitle>Pending Invitations</SettingsCardTitle>

			<Suspense fallback={<TableFullSkeleton className="w-full" rows={10} />}>
				<InvitationsTable />
			</Suspense>
		</SettingsCard>
	)
}

function RouteSkeleton() {
	return (
		<SettingsCard>
			<SettingsCardTitle>Pending Invitations</SettingsCardTitle>

			<TableFullSkeleton className="w-full" rows={10} />
		</SettingsCard>
	)
}
